import { UsersData } from 'src/store/interface';
import { isServer } from 'src/utils/common';
import { DEVICE_TYPES } from 'src/utils/constants/AppConstants';
import {
  CountryCode,
  DisplayLanguage,
  GUEST
} from 'src/utils/constants/stringConstants';
import { DEVICE_WIDTH_CONSTANTS } from 'src/utils/constants/utilConstants';
import { getDeviceWidth } from 'src/utils/getDeviceWidth';

import { mixpanelObject } from '../../utils/analytics';
import { ctaEvent } from '../../utils/analytics/mixpanel/mixpanelEventsHelper';
import { clearCtaEventsProperty } from '../../utils/analytics/mixpanel/mixpanelHelper';
import {
  MIXPANEL_ELEMENT,
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_HORIZONTAL_INDEX
} from '../../utils/analytics/mixpanel/mixpanelConstants';

type MenuCountsType = {
  [key: string]: {
    [key: number | string]: {
      [key: string]: number;
    };
  };
};

const menuCounts: MenuCountsType = {
  [DisplayLanguage.TAMIL]: {
    1800: { in: 8, global: 7 },
    1366: { in: 4, global: 3 },
    default: { in: 3, global: 2 }
  },
  [DisplayLanguage.MALAYALAM]: {
    1800: { in: 10, global: 8 },
    1366: { in: 5, global: 4 },
    default: { in: 4, global: 3 }
  },
  [DisplayLanguage.KANNADA]: {
    1800: { in: 13, global: 11 },
    1366: { in: 7, global: 6 },
    default: { in: 6, global: 5 }
  },
  [DisplayLanguage.ENGLISH]: {
    1800: { in: 9, global: 12 },
    1366: { in: 5, global: 7 },
    default: { in: 3, global: 5 }
  }
};

const displayLanguageArray: Array<string> = [
  DisplayLanguage.TAMIL,
  DisplayLanguage.MALAYALAM,
  DisplayLanguage.KANNADA
];

export const getMenuCount = (displayLanguage: string, countryCode: string) => {
  const countryCode_IN = CountryCode.IN.toLowerCase();
  const isGlobalCheck = countryCode.toLowerCase() !== countryCode_IN;
  const innerWidth = getDeviceWidth() as number;
  const language = displayLanguageArray.includes(displayLanguage)
    ? displayLanguage
    : DisplayLanguage.ENGLISH;
  const languageSpecificMenuCount = menuCounts[language.toLowerCase()];

  let displayMenuCount =
    languageSpecificMenuCount.default[
      isGlobalCheck ? CountryCode.GLOBAL : countryCode_IN
    ];

  if (innerWidth >= 1800)
    displayMenuCount =
      languageSpecificMenuCount[1800][
        isGlobalCheck ? CountryCode.GLOBAL : countryCode_IN
      ];

  if (innerWidth >= 1366 && innerWidth < 1800)
    displayMenuCount =
      languageSpecificMenuCount[1366][
        isGlobalCheck ? CountryCode.GLOBAL : countryCode_IN
      ];
  return displayMenuCount;
};

export const calculateScrollHeight = (deviceWidth: number) => {
  if (deviceWidth) {
    if (deviceWidth < 480) return 8;
    if (deviceWidth < 1200) return 28;
    return 16;
  }
  return 8;
};

export const burgerCTAMixpanelEvent = (element: string, buttonType: string) => {
  const BurgerMenuIndex = '0';
  // mixpanel Initailization start
  clearCtaEventsProperty(mixpanelObject);
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, element);
  mixpanelObject.setProperty(MIXPANEL_BUTTON_TYPE, buttonType);
  mixpanelObject.setProperty(MIXPANEL_HORIZONTAL_INDEX, BurgerMenuIndex);
  ctaEvent();
  // mixpanel Initailization end
};

export const getUserName = (usersData: UsersData | null) => {
  if (usersData?.first_name && usersData?.first_name !== 'undefined') {
    return usersData?.first_name;
  } else if (usersData) {
    return GUEST;
  }
  return '';
};

export const getLogoWidth = (deviceType: string, innerWidth: number) => {
  if (isServer()) {
    return deviceType === DEVICE_TYPES.DESKTOP ? 46 : 32;
  } else {
    return innerWidth < DEVICE_WIDTH_CONSTANTS.deviceWidth1200 ? 32 : 46;
  }
};

export const getUserContactInfo = (userData: UsersData) => {
  let contactInfo = '';
  if (
    userData.email &&
    userData.email !== 'null' &&
    userData.email !== 'undefined'
  ) {
    contactInfo = userData.email;
  }
  return contactInfo;
};
